import React from 'react';
import PortraitImage from './PortraitImage';

export interface ScheduleEventAttendanceProps {
  requiredPortraits?: string[] | undefined;
  absentPortraits?: string[] | undefined;
}

const ScheduleEventAttendance: React.FC<ScheduleEventAttendanceProps> = ({
  requiredPortraits,
  absentPortraits,
}) => {
  const portraits = Array.isArray(requiredPortraits) ? requiredPortraits : [];
  const absentSet = new Set(Array.isArray(absentPortraits) ? absentPortraits : []);

  if (portraits.length === 0) {
    return null;
  }

  return (
    <div className="schedule-event-portraits">
      {portraits.map((portraitId, index) => {
        const resolvedId = portraitId || 'generic';
        const isAbsent = absentSet.has(resolvedId);
        return (
          <div
            key={`${portraitId}-${index}`}
            className={isAbsent ? 'schedule-event-portrait is-unconfirmed' : 'schedule-event-portrait'}
          >
            <PortraitImage
              portraitId={resolvedId}
              variant="thumbnail"
              alt={`Event participant ${index + 1}`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ScheduleEventAttendance;
